import { render, staticRenderFns } from "./gerenxinxi.vue?vue&type=template&id=338aa2e6&"
import script from "./gerenxinxi.vue?vue&type=script&lang=ts&"
export * from "./gerenxinxi.vue?vue&type=script&lang=ts&"
import style0 from "./gerenxinxi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports